import React from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import TeamOverlay from '../components/TeamOverlay';
import BackupImage from '../images/coming-soon.jpg';

export default class Team extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			department: 'All',
			teamOverlayOpen: false,
			overlayMember: ''
		};
		this.handleDepartmentChange = this.handleDepartmentChange.bind(this);
		this.handleDepartmentDropdownChange = this.handleDepartmentDropdownChange.bind(this);
		this.openTeamOverlay = this.openTeamOverlay.bind(this);
		this.changeActiveOverlayMember = this.changeActiveOverlayMember.bind(this);
		this.closeTeamOverlay = this.closeTeamOverlay.bind(this);
	}

	handleDepartmentChange(e) {
		this.setState({
			department: e.target.title
		});
	}

	handleDepartmentDropdownChange(e) {
		this.setState({
			department: e.target.value
		});
	}

	openTeamOverlay(e) {
		const targetElement = document.querySelector('#team-overlay');

		disableBodyScroll(targetElement);
		this.setState({
			teamOverlayOpen: true,
			overlayMember: e.currentTarget.title
		});
	}

	changeActiveOverlayMember(e) {
		this.setState({
			overlayMember: e.currentTarget.title
		});
	}

	closeTeamOverlay() {
		clearAllBodyScrollLocks();
		this.setState({
			teamOverlayOpen: false,
			overlayMember: ''
		});
	}

	// eslint-disable-next-line class-methods-use-this
	componentWillUnmount() {
		clearAllBodyScrollLocks();
	}

	render() {
		const { subHeading, heading, teamDepartments, teamMembers } = this.props;

		// Filter and sort
		const matchingMembers = teamMembers.filter(member => this.state.department === 'All' || member.departments.some(d => d.name === this.state.department));

		const memberGroups = matchingMembers.reduce(
			(acc, member) => {
				if (member.order < 100) {
					acc.tier1Sort.push(member);
				} else if (member.order >= 900) {
					acc.dogSort.push(member);
				} else if (this.state.department !== 'All' && member.departments.some(d => d.name === 'Customer Care')) {
					// CC direct reports to steven will be caught by the < 100 clause,
					// only split CC if the sorting is not 'All' (otherwise senior management and CSRs are sorted alphabetical with all of PeopleSearch)
					// these rest of CC grouping is split between manually ordered senior management, and alphabetical team members
					if (member.order > 700) {
						acc.seniorCustomerCareSort.push(member);
					} else {
						acc.customerCareSort.push(member);
					}
				} else {
					// Everyone else is alphabetically sorted regardless of order/department
					acc.alphabeticalSort.push(member);
				}

				return acc;
			},
			{ tier1Sort: [], alphabeticalSort: [], seniorCustomerCareSort: [], customerCareSort: [], dogSort: [] }
		);

		const sortedMatchingMembers = [
			...memberGroups.tier1Sort.sort((a, b) => a.order - b.order),
			...memberGroups.alphabeticalSort.sort((a, b) => (a.name < b.name ? -1 : 1)),
			...memberGroups.seniorCustomerCareSort.sort((a, b) => (a.name < b.name ? -1 : 1)),
			...memberGroups.customerCareSort.sort((a, b) => (a.name < b.name ? -1 : 1)),
			...memberGroups.dogSort.sort((a, b) => a.order - b.order)
		];

		return (
			<div id="team">
				{this.state.teamOverlayOpen && (
					<TeamOverlay
						teamMembers={sortedMatchingMembers}
						activeMemberName={this.state.overlayMember}
						changeActiveOverlayMember={this.changeActiveOverlayMember}
						closeTeamOverlay={this.closeTeamOverlay}
					/>
				)}
				<div className="heading">
					<p>{subHeading}</p>
					<h3>{heading}</h3>
				</div>
				<ul className="department-list head-list team-filter">
					{teamDepartments.length > 1 && (
						<li className={this.state.department === 'All' ? 'active' : ''}>
							<div title="All" onClick={this.handleDepartmentChange}>
								All
							</div>
						</li>
					)}
					{teamDepartments.map((department, i) => (
						<li className={this.state.department === department.name ? 'active' : ''} key={i}>
							<div title={department.name} onClick={this.handleDepartmentChange}>
								{department.name}
							</div>
						</li>
					))}
				</ul>
				{teamDepartments.length > 1 && (
					<div className="dropdown">
						<p>View:</p>
						<select name="sort" onChange={this.handleDepartmentDropdownChange} value={this.state.department}>
							<option value="All" title="All">
								All
							</option>
							{teamDepartments.map((department, i) => (
								<option key={i} value={department.name} title={department.name}>
									{department.name}
								</option>
							))}
						</select>
					</div>
				)}
				<div className="team-members-container">
					{sortedMatchingMembers.map((member, i) => (
						<div
							className={`team-member ${member.departments.map(d => d.name).includes(this.state.department) || this.state.department === 'All' ? 'active' : ''}`}
							key={member.name}
							title={member.name}
							onClick={this.openTeamOverlay}
							role="button"
							onKeyPress={() => {}}
							tabIndex={i}
						>
							{member.image ? (
								<GatsbyImage image={member.altImage ? getImage(member.altImage) : getImage(member.image)} alt={member.name} />
							) : (
								<img src={BackupImage} alt={member.name} />
							)}
							<div>
								<p className="name">{member.name}</p>
								<p className="title">{member.title}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}
}
